import { createContext } from "react";

export const ModalGeneralContext = createContext(null);
export const ModalBottomBarContext = createContext(null);
